import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, createUrlTreeFromSnapshot, UrlTree } from '@angular/router';
import { Observable, switchMap, take } from 'rxjs';
import { InboxService } from '../../../core/src/lib/inbox.service';

@Injectable({
  providedIn: 'root',
})
export class SmsAccessGuard {
  constructor(readonly inboxService: InboxService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.inboxService.canAccessSMS$.pipe(
      take(1),
      switchMap(async (canAccessSMS) => canAccessSMS || createUrlTreeFromSnapshot(route, ['../'])),
    );
  }
}
